import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import {
  getpending,
  deleteRfQ,
  userRFQ,
  getNote,
  viewNotes,
} from "../../api/requestForQuotation.api";
import {
  FileAddOutlined,
  EyeOutlined,
  UserOutlined,
  DeleteOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";

import { returnedOrder } from "../../api/order.api";
import {
  Table,
  Button,
  Tag,
  Modal,
  Row,
  Col,
  Typography,
  Space,
  Image,
  Input,
  InputNumber,
  DatePicker,
  Select,
  Tooltip,
  Divider,
} from "antd";
import Swal from "sweetalert2";
import {
  capitalizeFirstLetter,
  formatDate,
  formatDate2,
  formatDateWithTime,
} from "../../helpers/utils";
import DefaultLoader from "../Shared/loader";

const { Text } = Typography;

export const PendingData = () => {
  const [viewData, setViewData] = useState({});
  const [quotationData, setQuotationData] = useState({});
  const [openView, setOpenView] = React.useState(false);
  const [openQuotation, setOpenQuotation] = React.useState(false);
  const [rfqRow, setRfqRow] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deadline, setDeadline] = useState(dayjs());
  const [dateString, setDateString] = useState("");
  const [price, setPrice] = useState(1.0);
  const [quantity, setQuantity] = useState(1);
  const [shipping, setShipping] = useState(1);
  const [priority, setPriority] = useState("low");
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);

  //view the user of the RfQ
  const [userData, setUserData] = useState({});
  const [openUser, setOpenUser] = React.useState(false);

  //search
  const [searchValue, setSearchValue] = useState("");
  const [searchData, setSearchData] = useState([]); // This is the data that will be filtered

  const handleView = async (data) => {
    setViewData(data);
    setOpenView(true);
  };

  const handleUser = async (id) => {
    const response = await userRFQ(id);
    if (response.status === 200) {
      setUserData(response.data);
      setOpenUser(true);
    }
  };

  const handleQuotation = async (data) => {
    setQuotationData(data);
    setDeadline(dayjs(data.deadline));
    setDateString(formatDate2(data.deadline));
    setQuantity(data.targetqty);
    setOpenQuotation(true);
  };

  const onChange = (date, dateStr) => {
    setDeadline(dayjs(dateStr));
    setDateString(dateStr);
  };

  const resetQuotation = () => {
    setPrice(1.0);
    setQuantity(1);
    setShipping(1);
    setComment("");
    setDeadline(dayjs());
  };

  const handleQuotationSubmit = async () => {
    // check price, shipping,deadline
    if (price <= 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Price must be greater than 0",
      });
      return;
    }
    if (shipping === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Shipping must not be empty",
      });
      return;
    }
    if (dateString === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Deadline must not be empty",
      });
      return;
    }

    const params = {
      delivery_address_id:
        quotationData.deliveryAddressId || "No Delivery Address",
      rfqId: quotationData._id,
      price: price,
      shipping: shipping,
      comment: comment,
      deadline: dateString, // using yyyy-mm-dd format
      image: quotationData.image,
      priority: priority,
      prod_name: quotationData.prodName,
      quantityavailable: quantity,
    };
    setLoading(true);
    try {
      const response = await returnedOrder(params);
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Quotation created successfully",
        });
        setOpenQuotation(false);
        resetQuotation();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id, name) => {
    try {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "deleteButton1",
          cancelButton: "veiwButton1",
        },
        //buttonsStyling: false,
      });

      const result = await swalWithBootstrapButtons.fire({
        title: "Are you sure?",
        text: "You want to delete " + name + "?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        reverseButtons: true,
      });

      if (result.isConfirmed) {
        // Make the axios delete request
        const response = await deleteRfQ(id);
        if (response.status === 200) {
          swalWithBootstrapButtons.fire(
            "Deleted!",
            "Your file has been deleted.",
            "success"
          );
          // Update the table
          const newRfqRow = rfqRow.filter((row) => row._id !== id);
          setRfqRow(newRfqRow);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        swalWithBootstrapButtons.fire("Cancelled", "", "error");
      }
    } catch (error) {
      console.error(error);
    }
  };

  //view the user of the RfQ
  const [notesData, setNoteViewData] = useState({});

  const handleNotesView = async (id) => {
    const response = await viewNotes(id);
    if (response.status === 200) {
      setNoteViewData(response.data);
    }
  };

  //handle the add shipping HEE HEE
  const [notes, setNotes] = useState("");
  const [notedata, setNotesData] = useState({});
  const [openNotes, setOpenNotes] = React.useState(false);

  const handleNotes = async (data) => {
    setNotesData(data);
    setNotes(data.notes);

    setOpenNotes(true);
  };

  const resetNotes = () => {
    setNotes("");
  };

  const handleNotesSubmit = async () => {
    const params = {
      rfqId: notedata,
      notes: notes,
    };

    setLoading(true);
    try {
      const response = await getNote(params);
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Note Added Successfully",
        });
        resetNotes();
        handleNotesView(notedata);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const actionColumn = [
    {
      dataIndex: "rfq",
      title: "Image",
      key: "rfq",
      render: (_, params) => {
        return (
          <Image
            src={params.image}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src =
                "https://antswelead.sgp1.digitaloceanspaces.com/internal_files/335623101_583997373674210_5297548643792796750_n.jpg";
            }}
            alt="img"
            width={80}
          />
        );
      },
    },
    {
      dataIndex: "prodName",
      title: "PRODUCT NAME",
      key: "prodName",
    },
    { dataIndex: "targetqty", title: "QUANTITY", key: "targetqty" },
    {
      dataIndex: "deadline",
      title: "DEADLINE",
      key: "deadline",
      render(_, params) {
        return (
          <div>
            <p>{formatDate(params.deadline)}</p>
          </div>
        );
      },
    },

    {
      dataIndex: "status",
      title: "Status",
      key: "_id",
      render: (_, params) => {
        return (
          <Tag color={params.status === "pending" ? "magenta" : "green"}>
            {capitalizeFirstLetter(params.status)}
          </Tag>
        );
      },
    },

    {
      dataIndex: "action",
      title: "Action",
      key: "_id",
      render: (_, params) => {
        return (
          <>
            <Button
              //style={{ background: "green"}}
              size="large"
              shape="circle"
              onClick={() => {
                handleView(params);
              }}
            >
              <EyeOutlined style={{ color: "green" }} />
            </Button>
            <Divider type="vertical" />
            <Button
              //style={{ background: "skyblue"}}
              size="large"
              shape="circle"
              onClick={() => {
                handleUser(params._id);
              }}
            >
              <UserOutlined style={{ color: "skyblue" }} />
            </Button>
            <Divider type="vertical" />
            <Button
              //style={{background: "blue"}}
              size="large"
              shape="circle"
              onClick={() => {
                handleDelete(params._id, params.prodName);
              }}
              danger
            >
              <DeleteOutlined />
            </Button>
            <Divider type="vertical" />
            <Button
              size="large"
              shape="circle"
              onClick={() => {
                handleQuotation(params);
              }}
            >
              <FileDoneOutlined style={{ color: "#8B8000" }} />
            </Button>
          </>
        );
      },
    },
    {
      dataIndex: "notes",
      title: "Notes",
      key: "_id",
      render: (_, params) => {
        return (
          <>
            <Tooltip title="Add Notes">
              <div
                style={{ cursor: "pointer" }}
                onClick={() => {
                  handleNotes(params._id);
                  handleNotesView(params._id);
                }}
              >
                <FileAddOutlined style={{ fontSize: "50px" }} />
              </div>
            </Tooltip>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getpending();
        const data = await response.data;
        setRfqRow(data.Requests);
        setIsLoading(false);
      } catch (error) {
        setError(error);
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  if (isLoading) {
    return <DefaultLoader />;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <>
      {/* Another modal for viewing all details of the selected data */}
      <Modal
        open={openView}
        onCancel={() => {
          setOpenView(false);
        }}
        footer={null}
        title={"View Details"}
        width={800}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Image src={viewData?.image} alt="img" width={300} />

            <Space direction="vertical">
              <Text strong></Text>
              <Text strong>Address</Text>
              {viewData?.format_address ? (
                <Text>
                  {/* {address.regionName}, {address.province},{" "}
                  {address.municipalitName}, {address.baranggayName},{" "}
                  {address.street}, {address.zipcode} */}
                  {viewData?.format_address}
                </Text>
              ) : (
                <Text>No address available</Text>
              )}
            </Space>
          </Col>
          <Col span={12}>
            <Space direction="vertical">
              <Space direction="vertical">
                <Text strong>Product Name</Text>
                <Text>{viewData?.prodName}</Text>
              </Space>
              <Space direction="vertical">
                <Text strong>Target Quantity</Text>
                <Text>{viewData?.targetqty}</Text>
              </Space>
              <Space direction="vertical">
                <Text strong>Deadline</Text>
                <Text>{viewData?.deadline}</Text>
              </Space>
              <Space direction="vertical">
                <Text strong>Status</Text>
                <Text>{viewData?.status}</Text>
              </Space>
              <Space direction="vertical">
                <Text strong>Description</Text>
                <Text>{viewData?.description}</Text>
              </Space>
              <Space direction="vertical">
                <Text strong>Specifications</Text>
                <Text>{viewData?.specs}</Text>
              </Space>
              <Space direction="vertical">
                <Text strong>Files</Text>
                <a href={viewData?.files} target="_blank" rel="noreferrer">
                  {viewData?.files?.split("/").pop()}
                </a>
              </Space>
            </Space>
          </Col>
        </Row>
      </Modal>

      <Modal
        open={openQuotation}
        onCancel={() => {
          setOpenQuotation(false);
          resetQuotation();
        }}
        title={"Set Quotation"}
        width={800}
        footer={[
          <Button
            key="back"
            onClick={() => {
              setOpenQuotation(false);
              resetQuotation();
            }}
          >
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={handleQuotationSubmit}
          >
            Submit
          </Button>,
        ]}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Space direction="vertical">
              <Image src={quotationData?.image} alt="img" width={300} />
              <Space direction="vertical">
                <Text strong>Product Name</Text>
                <Text>{capitalizeFirstLetter(quotationData?.prodName)}</Text>
              </Space>
              <Space direction="vertical">
                <Text strong>Target Quantity</Text>
                <Text>{quotationData?.targetqty}</Text>
              </Space>

              <Space direction="vertical">
                <Text strong>Status</Text>
                <Text>{capitalizeFirstLetter(quotationData?.status)}</Text>
              </Space>
              <Space direction="vertical">
                <Text strong>Description</Text>
                <Text>{quotationData?.description}</Text>
              </Space>
            </Space>
          </Col>
          <Col span={12}>
            <Space direction="vertical">
              <Space direction="vertical">
                <Text strong>Specifications</Text>
                <Text>{quotationData?.specs}</Text>
              </Space>
              <Space direction="vertical">
                <Text strong>Files</Text>
                <a href={quotationData?.files} target="_blank" rel="noreferrer">
                  {quotationData?.files?.split("/").pop()}
                </a>
              </Space>
              <Space direction="vertical">
                <Text strong>Deadline</Text>
                {openQuotation ? (
                  <DatePicker
                    onChange={onChange}
                    defaultValue={deadline}
                    value={deadline}
                  />
                ) : null}
              </Space>
              <Space direction="vertical">
                <Text strong>Price</Text>
                <InputNumber
                  step="0.01"
                  value={quotationData?.estimatedPrice}
                  onChange={(newPrice) => {
                    setPrice(newPrice);
                  }}
                ></InputNumber>
              </Space>
              <Space direction="vertical">
                <Text strong>Quantity</Text>
                <InputNumber
                  value={quotationData?.targetqty}
                  onChange={(newQuantity) => {
                    setQuantity(newQuantity);
                  }}
                ></InputNumber>
              </Space>
              <Space direction="vertical">
                <Text strong>Priority</Text>
                <Select
                  defaultValue="low"
                  style={{ width: 120 }}
                  onChange={(value) => {
                    setPriority(value);
                  }}
                  options={[
                    { value: "low", label: "Low" },
                    { value: "medium", label: "Medium" },
                    { value: "high", label: "High" },
                  ]}
                />
              </Space>
              <Space direction="vertical">
                <Text strong>Shipping Fee</Text>
                <InputNumber
                  step="0.01"
                  value={shipping}
                  onChange={(newQuantity) => {
                    setShipping(newQuantity);
                  }}
                ></InputNumber>
              </Space>
              <Space direction="vertical">
                <Text strong>Comments</Text>
                <Input.TextArea
                  value={comment}
                  onChange={(e) => {
                    setComment(e.target.value);
                  }}
                ></Input.TextArea>
              </Space>
            </Space>
          </Col>
        </Row>
      </Modal>

      {/* User Quotation */}
      <Modal
        open={openUser}
        onCancel={() => {
          setOpenUser(false);
          setUserData();
        }}
        title={"User Details"}
        width={800}
        footer={[
          <Button
            key="back"
            onClick={() => {
              setOpenUser(false);
              setUserData();
            }}
          >
            Back
          </Button>,
        ]}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Space direction="vertical">
              <Space direction="vertical">
                <Text strong>Name</Text>
                <Text>
                  {userData?.firstName} {userData?.lastName}
                </Text>
              </Space>
            </Space>
          </Col>
          <Col span={12}>
            <Space direction="vertical">
              <Space direction="vertical">
                <Text strong>Contact Details</Text>
                <Text>{userData?.email}</Text>
                <Text>{userData?.mobileNumber}</Text>
              </Space>
              <Space direction="vertical">
                <Text strong>Vip Status</Text>
                <Text>
                  {" "}
                  {userData?.isVIP === false ? (
                    <span style={{ color: "red" }}>No</span>
                  ) : (
                    <span style={{ color: "green" }}>Yes</span>
                  )}
                </Text>
              </Space>
            </Space>
          </Col>
        </Row>
      </Modal>

      {/* modal of notes */}

      <Modal
        open={openNotes}
        onCancel={() => {
          setOpenNotes(false);
          resetNotes();
        }}
        title={"Set Notes"}
        width={1000}
        footer={[
          <Button
            key="back"
            onClick={() => {
              setOpenNotes(false);
            }}
          >
            Cancel
          </Button>,
        ]}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Space direction="vertical">
              <Space direction="vertical">
                <Text strong>
                  Product Name : {notesData?.rfqData?.prodName}
                </Text>
                <Text>
                  {/* gets the no note */}
                  <ul>
                    {notesData.total > 0 ? (
                      //getting the note
                      <ul
                        style={{
                          backgroundColor: "#FAFAFA",
                          width: "600px",
                          borderRadius: "10px",
                          padding: "15px",
                          listStyle: "none",
                          maxHeight: "400px",
                          overflow: "auto",
                        }}
                      >
                        {notesData.notes
                          .sort(
                            (a, b) =>
                              new Date(b.createdAt) - new Date(a.createdAt)
                          )
                          .map((note) => (
                            <li
                              key={note._id}
                              style={{
                                backgroundColor: "white",
                                borderRadius: "10px",
                                padding: "5px",
                                margin: "2px",
                                border: "#ECECEC solid 1px",
                              }}
                            >
                              <span
                                style={{
                                  color: "green",
                                  fontSize: "11px",
                                  paddingRight: "20px",
                                }}
                              >
                                {formatDateWithTime(note.createdAt)}:
                              </span>
                              {note.notes}{" "}
                            </li>
                          ))}
                      </ul>
                    ) : (
                      <Text>No notes</Text>
                    )}
                  </ul>
                </Text>
              </Space>
            </Space>
          </Col>

          <Col span={12} push={3}>
            <Space direction="vertical">
              <Space direction="vertical">
                <Text strong>Add Notes</Text>
                <Input.TextArea
                  style={{ width: "350px", height: "250px" }}
                  value={notes}
                  onChange={(newnotes) => {
                    setNotes(newnotes.target.value);
                  }}
                ></Input.TextArea>

                <Button
                  style={{
                    width: "350px",
                    fontSize: "20px",
                    height: "40px",
                    backgroundColor: "#82CD47",
                  }}
                  key="submit"
                  type="primary"
                  loading={loading}
                  onClick={handleNotesSubmit}
                >
                  Submit
                </Button>
              </Space>
            </Space>
          </Col>
        </Row>
      </Modal>

      {/* search */}
      <Text>
        <Input
          style={{ margin: "20px", width: "600px" }}
          placeholder="Search Product Name"
          value={searchValue}
          onChange={(e) => {
            const currValue = e.target.value;
            setSearchValue(currValue);
            const filteredData = rfqRow.filter((entry) => {
              if (
                entry.prodName.toLowerCase().includes(currValue.toLowerCase())
              ) {
                return entry;
              }
              return null;
            });
            setSearchData(filteredData);
          }}
          disabled={!rfqRow || rfqRow.length === 0}
        />
      </Text>

      <Table
        columns={actionColumn}
        dataSource={searchData.length > 0 ? searchData : rfqRow}
        pagination={{ pageSize: 5 }}
        rowKey="_id"
      />
    </>
  );
};
